export function GetLocalStorage(name){
  return localStorage.getItem(name) || false;
}

export function SetLocalStorage(name,value){
  localStorage.setItem(name,value);
}
